import { api } from "@/api";

import { QueryProps } from "@/types/Api";
import { FeedType, SportEvent } from "@/types/SportsApiResponses";
import {
  DEFAULT_VIRTUAL_SPORT_TYPE,
  VirtualSportType,
} from "./virtualSportType";

export interface GetVirtualSportEventParams {
  id: number | string;
  lang: string;
  feedType: FeedType;
  providerId: number | string;
  // Scopes the server's market-group lookup (virtual basketball reads the
  // basketball market names). Defaults to virtual football, whose scope is the
  // same default one an omitted sportType gets.
  sportType?: VirtualSportType;
}

// A single selected VR match (content pane) — dedicated so the shared
// `getSportEventNew` carries no VR concern.
export const getVirtualSportEvent = async (
  props: QueryProps<GetVirtualSportEventParams>
): Promise<SportEvent | undefined> => {
  const {
    id,
    sportType = DEFAULT_VIRTUAL_SPORT_TYPE,
    ...queryParams
  } = props.params;
  const res = await api.client.get(`/sport-events-new/${id}`, {
    signal: props.signal,
    params: { ...queryParams, sportType },
  });
  return res.data;
};
